/**
 * Suspense das telas carregadas sob demanda (lazy). Enquanto o chunk da tela chega
 * (rede ou precache do service worker), mostra só o FUNDO da tela — sem spinner e sem
 * flash branco, como a transição do app nativo.
 */
import { useDesktop } from "@/ui/useMediaQuery";
import { type ReactNode, Suspense } from "react";
import s from "./Carregando.module.css";

/**
 * WEB (desktop): enquanto o código da tela chega, um skeleton com a faixa azul do cabeçalho
 * (mesma altura da última tela) e cartões — em vez da área vazia no meio da página.
 */
function EsqueletoDesktop() {
  return (
    <div className={s.esqueleto} aria-busy="true">
      <div className={s.esqFaixa} />
      <div className={s.esqColuna}>
        <div className={s.esqTitulo} />
        <div className={s.esqGrade}>
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className={s.esqCartao}>
              <div className={s.esqLinhaCurta} />
              <div className={s.esqLinha} />
              <div className={s.esqLinhaMedia} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function FundoTela({ cor = "#f2f7f9" }: { cor?: string }) {
  const desktop = useDesktop();
  // Telas de fundo claro (abas) ganham o skeleton no desktop; as de fundo azul (entrada,
  // chat) e o celular continuam só com o fundo, como antes.
  if (desktop && cor === "#f2f7f9") return <EsqueletoDesktop />;
  return <div className={s.fundo} style={{ backgroundColor: cor }} aria-busy="true" />;
}

export function Carregando({ children, cor = "#f2f7f9" }: { children: ReactNode; cor?: string }) {
  return <Suspense fallback={<FundoTela cor={cor} />}>{children}</Suspense>;
}
